import React from 'react';
import './_page-14.scss';
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";

export default function Page14() {
    const name = 'page14'

    const {data, setData} = useVMStore()

    return (
        <Form className='page-14'>
            <Form.Group controlId="vm_note">
                <Form.Control value={data[name]}
                              as="textarea"
                              rows={10}
                              placeholder='Beschreibungstext...'
                              onChange={(e) => setData(e.target.value, "page14")}
                />
            </Form.Group>
        </Form>
    );
}
